var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icn-24",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99967 16.6666C13.6816 16.6666 16.6663 13.6818 16.6663 9.99992C16.6663 6.31802 13.6816 3.33325 9.99967 3.33325C6.31778 3.33325 3.33301 6.31802 3.33301 9.99992C3.33301 13.6818 6.31778 16.6666 9.99967 16.6666ZM10.7056 11.8045L10.8556 6.28776H9.1437L9.29758 11.8045H10.7056ZM9.34759 13.9973C9.52969 14.1768 9.74769 14.2666 10.0016 14.2666C10.2478 14.2666 10.462 14.1768 10.6441 13.9973C10.8287 13.8177 10.9223 13.5997 10.9249 13.3433C10.9223 13.0919 10.8287 12.8765 10.6441 12.697C10.462 12.5174 10.2478 12.4277 10.0016 12.4277C9.74769 12.4277 9.52969 12.5174 9.34759 12.697C9.1655 12.8765 9.07574 13.0919 9.0783 13.3433C9.07574 13.5997 9.1655 13.8177 9.34759 13.9973Z",
    fill: "#FED02F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcn);
export default __webpack_public_path__ + "static/media/warning-icn.d980b15ed6ad5fc5a773cc742b3a02b6.svg";
export { ForwardRef as ReactComponent };